export enum CLIENTS {
  JAZZX = 'JAZZX',
  REVOLUTION = 'REVOLUTION',
}

/**
 * Client ID type based on enum values
 */
export type ClientId = `${CLIENTS}`;
